import { render, staticRenderFns } from "./cataloguefiledetails.vue?vue&type=template&id=d089987e"
import script from "./cataloguefiledetails.vue?vue&type=script&lang=js"
export * from "./cataloguefiledetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports